
const pageNum = {
  state: {
    num:1
  },

  mutations: {
    SET_PAGENUM: (state, item) => {
      console.log(`vuux page:${item}`)
      state.num = item
    }
  },

  actions: {

  }
}

export default pageNum
